import { ManageWageAccount } from "../../../../components/AddOns/Accounting/ManageWageAccount";
import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const ManageWageAccountPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Manage Wage Account"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={<ManageWageAccount />}
    />
  );
};
